import { render, staticRenderFns } from "./GroupBookingList.vue?vue&type=template&id=f48e8704&scoped=true&lang=html&"
import script from "./GroupBookingList.vue?vue&type=script&lang=js&"
export * from "./GroupBookingList.vue?vue&type=script&lang=js&"
import style0 from "./GroupBookingList.vue?vue&type=style&index=0&id=f48e8704&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48e8704",
  null
  
)

export default component.exports